package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.*
import core.constants.TextKeys
import core.enums.EActivityStateDB
import de.emgress.baskets.core.http.HttpClientJS
import de.emgress.baskets.modules.components.Divider
import dtos.games.outgoing.GameInfoDTOOut
import dtos.sponsor.SponsorDTOOut
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.*
import org.w3c.dom.SMOOTH
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollToOptions

@Composable
fun GamesSchedule() {

    val mScope = rememberCoroutineScope()
    val mClient = HttpClientJS()

    val mGames by produceState<List<GameInfoDTOOut>>(emptyList()) {
        value = mClient.getSchedule()
    }

    val mSponsor by produceState<SponsorDTOOut?>(null) {
        value = mClient.getScheduleSponsor().firstOrNull()
    }

    val mNextGame = remember(mGames) {
        mGames.sortedBy { it.mDateAndTime }.firstOrNull { it.mDateAndTime > Clock.System.now().toEpochMilliseconds() }
    }

    val mLastOrCurrentGame = remember(mGames) {
        mGames.sortedBy { it.mDateAndTime }.lastOrNull { it.mDateAndTime <= Clock.System.now().toEpochMilliseconds() }
    }

    val mGameWithCountdown = remember(mNextGame, mLastOrCurrentGame) {
        if(mLastOrCurrentGame?.mActivityState == EActivityStateDB.ACTIVE) null else mNextGame
    }

    LaunchedEffect(true) {
        if (window.location.search.contains("autoscroll=true")) {
            mScope.launch {
                while (document.getElementById(TextKeys.SCHEDULE_SCROLL_ID) == null) {
                    delay(500)
                }

                document.getElementById(TextKeys.SCHEDULE_SCROLL_ID)?.let {
                    val y = it.getBoundingClientRect().top + window.pageYOffset
                    window.scrollTo(ScrollToOptions(top = y, behavior = ScrollBehavior.SMOOTH))
                }
            }
        }
    }

    mGames.sortedBy { it.mDateAndTime }.forEachIndexed { index, game ->
        ScheduleItem(
            mGame = game,
            mSponsor = mSponsor,
            mIndex = index,
            mIsLastGame = game.mGameId == mLastOrCurrentGame?.mGameId,
            mIsNextGame = game.mGameId == mNextGame?.mGameId,
            mShowCountdown = game.mGameId == mGameWithCountdown?.mGameId
        )

        if (index < mGames.lastIndex) {
            Divider()
        }
    }
}